import { Clock, Loader2, CheckCircle2, XCircle } from 'lucide-react';

import { Badge } from '@/components/ui/Badge';
import { ExportStatus } from '@/services/VoiceTone';

interface ExportStatusBadgeProps {
  status: ExportStatus;
}

export function ExportStatusBadge({ status }: ExportStatusBadgeProps) {
  const statusConfig = {
    active: {
      label: 'active',
      variant: 'secondary' as const,
      icon: Loader2,
      className:
        'bg-muted text-muted-foreground hover:bg-gray-300 hover:text-gray-800',
    },
    waiting: {
      label: 'waiting',
      variant: 'secondary' as const,
      icon: Loader2,
      className:
        'bg-muted text-muted-foreground hover:bg-gray-300 hover:text-gray-800',
    },
    completed: {
      label: 'completed',
      variant: 'default' as const,
      icon: CheckCircle2,
      className:
        'bg-green-100 text-green-700 hover:bg-green-200 hover:text-green-800',
    },
    failed: {
      label: 'failed',
      variant: 'destructive' as const,
      icon: XCircle,
      className: 'bg-red-100 text-red-700 hover:bg-red-200 hover:text-red-800',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon || Clock;

  return (
    <Badge variant={config.variant} className={config.className}>
      <Icon
        className={`mr-1.5 size-3 ${status === ExportStatus.ACTIVE || status === ExportStatus.WAITING ? 'animate-spin' : ''}`}
      />
      {config.label}
    </Badge>
  );
}
